module.exports = {
    // frontendURL: 'http://localhost:3000/',
    frontendURL: 'https://spashal-github-io.pages.dev/',
    // backendURL: 'http://127.0.0.1:8787/',
    backendURL: "https://blog-site.palash-sharma.workers.dev/"
};